import type React from 'react';

import type { ErrorHandlerProps } from '#src/app/pages/actions/pageContext';

export const PetitionActionsErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for Petition Actions page (error: ${error})`);
};
